import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  useDropdown,
  UsecitiesDropdowns,
  useStatesDropdowns,
  useEmpResgiterMutation,
  useIndustries,
} from "../../actions/authActions";
import { useEmployer } from "../../actions/dashboardActions";
import textWeight from "../../utils/textWeight";

export default () => {
  const navigate = useNavigate();
  const { TextWeight } = textWeight();
  const [loadingToapi, setLoadingToapi] = useState(false);
  const [countryCode, setCountryCode] = useState(null);
  const user = useSelector((state) => state.app.userData.userData);
  const dispatch = useDispatch();
  const [files, setFiles] = useState({
    logo: null,
  });
  const [isDragging, setIsDragging] = useState({
    logo: null,
  });
  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files.length > 0) {
      setFiles((prevFiles) => ({
        ...prevFiles,
        [name]: files[0],
      }));
    }
  };

  const clearFileChange = (name) => {
    setFiles((prevFiles) => ({
      ...prevFiles,
      [name]: null,
    }));
  };
  const handleDrop = (e, fieldName) => {
    e.preventDefault();
    setIsDragging((prev) => ({ ...prev, [fieldName]: false }));

    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile && droppedFile.type.startsWith("image/")) {
      setFiles((prevFiles) => ({
        ...prevFiles,
        [fieldName]: droppedFile,
      }));
    }
  };

  const handleDragEnter = (fieldName) => {
    setIsDragging((prev) => ({ ...prev, [fieldName]: true }));
  };
  const handleDragLeave = (fieldName) => {
    setIsDragging((prev) => ({ ...prev, [fieldName]: false }));
  };

  const { data: employerData, isLoading: isLoadingprefilled } = useEmployer(
    user?.employer?.id
  );
  const {
    handleSubmit,
    setValue,
    watch,
    register,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: employerData?.name || "",
      email: employerData?.email || "",
      city_id: employerData?.city_id || "",
      countries: employerData?.country_id || "",
      state_id: employerData?.state_id || "",
      zip_code: employerData?.zip_code || "",
      contact_number: employerData?.phone || "",
      // night_phone: employerData?.night_phone || '',
      address_line_1: employerData?.address_line_1 || "",
      contact_person: employerData?.contact_person || "",
      registration_number: employerData?.registration_number || "",
      no_of_employees: employerData?.no_of_employees || "",
      industry: employerData?.industry_id || "",
      website: employerData?.website || "",
    },
  });
  const { data: dropdowns, isLoading, isError, error } = useDropdown();
  const {
    data: industriesData,
    isError: isErrorIndustries,
    error: errorIndustries,
  } = useIndustries();
  const selectedCountry = watch("countries");
  const selectedstate = watch("state_id");
  const { data: states, isLoading: isLoadingStates } =
    useStatesDropdowns(selectedCountry);
  const { data: cities, isLoading: citiesisLoading } =
    UsecitiesDropdowns(selectedstate);

  useEffect(() => {
    if (
      !isLoadingprefilled &&
      employerData &&
      Object.keys(employerData).length > 0
    ) {
      setValue("name", employerData?.name);
      setValue("email", employerData?.email);
      setValue(
        "city_id",
        employerData?.city_id ? String(employerData?.city_id) : ""
      );
      setValue("zip_code", employerData?.zip_code);
      setValue("address_line_1", employerData?.address_line_1);
      setValue("contact_number", employerData?.phone);
      setValue("contact_person", employerData?.contact_person);
      setValue("no_of_employees", employerData?.no_of_employees);
      setValue("industry", employerData?.industry_id);
      setValue(
        "website",
        employerData?.website ? String(employerData?.website) : ""
      );
      setValue("registration_number", employerData?.registration_number);
      // setValue("night_phone", employerData?.night_phone);
      setValue(
        "countries",
        employerData?.country_id ? String(employerData?.country_id) : ""
      );
      setValue(
        "state_id",
        employerData?.state_id ? String(employerData?.state_id) : ""
      );
    }
  }, [employerData, isLoadingprefilled, setValue]);

  const mutation = useEmpResgiterMutation(
    employerData?.id,
    setLoadingToapi,
    navigate,
    dispatch
  );
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading Countries: {error.message}
        </p>
      </div>
    );
  }
  const onSubmit = (data, e) => {
    const userId = localStorage.getItem("userId");
    e.preventDefault();
    setLoadingToapi(true);
    const apiData = new FormData();
    apiData.append("name", data?.name || employerData?.name);
    apiData.append("email", data.email || employerData?.email);
    apiData.append("logo", files.logo);
    // apiData.append('banner', files.banner);
    apiData.append("city_id", data.city_id || employerData?.city_id);
    apiData.append("country_id", data.countries || employerData?.country_id);
    apiData.append("country_code", countryCode || employerData?.country_code);
    apiData.append("state_id", data.state_id || employerData?.state_id);
    apiData.append(
      "address_line_1",
      data.address_line_1 || employerData?.address_line_1
    );
    apiData.append("zip_code", data.zip_code || employerData?.zip_code);
    apiData.append("user_id", userId);
    apiData.append("phone", data.contact_number || employerData?.phone);
    apiData.append("website", data.website);
    apiData.append("industry_id", data?.industry);
    apiData.append("no_of_employees", data.no_of_employees);
    apiData.append("registration_number", data.registration_number);
    apiData.append("contact_person", data.contact_person);
    apiData.append("_method", "PUT");
    mutation.mutate(apiData);
  };
  if (isErrorIndustries) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading States: {errorIndustries.message}
        </p>
      </div>
    );
  }
  return {
    loadingToapi,
    setCountryCode,
    isDragging,
    handleFileChange,
    clearFileChange,
    handleDrop,
    handleDragEnter,
    handleDragLeave,
    handleSubmit,
    register,
    control,
    errors,
    dropdowns,
    isLoading,
    states,
    isLoadingStates,
    cities,
    citiesisLoading,
    onSubmit,
    files,
    employerData,
    isLoadingprefilled,
    industriesData,
    setValue,
    navigate,
    TextWeight,
  };
};
